import type { FC } from "react";

import type { IListItem } from "pro-features/components/AutocompleteWithTabs/handlers";
import type { EAssetType } from "app/UtilitiesAndConstants/types/assetType";

export interface IAsset {
    id: string;
    displayText: string;
    image: string;
    type: EAssetType;
    name?: string;

    /**
     * In case this asset is a segment, marks whether this is an account segment
     * or user segment.
     */
    isAccount?: boolean;
}

export interface ITabsProps {
    disabledTabText?: string;
    showAccountSegments?: boolean;
    showCustomTabsList?: boolean;
    UnlockModalLocation?: string;
    scrollMaxHeight?: number;
    CustomSegmentsSectionHeader?: FC;
    onBuildSegmentClick?: VoidFunction;
}

export interface IWebsiteResult {
    name: string;
    image: string;
}

export enum ESelectionType {
    SINGLE,
    MULTIPLE,
}

export type SelectionTypes = Pick<Record<EAssetType, ESelectionType>, EAssetType>;

export type SelectedItemsView = Record<string, IAsset>;

export interface ISelectionTypeProps {
    selectionTypes?: SelectionTypes;
    numberOfSelectableEntities?: number;
    numberOfSelectableSegments?: number;
    callbackOnCheckboxClick?: (isChecked: boolean, listItem: IListItem) => void;
}

export enum EDisableState {
    ENABLED,
    DISABLED_DUE_TO_DOMAIN_AND_SEGMENTS_OVERLAPPING,
    DISABLED_DUE_TO_MAX_ENTITIES_AMOUNT,
    DISABLED_DUE_TO_MAX_SEGMENTS_AMOUNT,
}

export interface IGetDisabledStateItem {
    item: { id: string; type: EAssetType; isDisabled?: boolean };
    selectedItemsView: SelectedItemsView;
    selectionTypeProps?: ISelectionTypeProps;
}

export interface IResolveDisabledStateParams {
    numberOfSelectableEntities: number;
    numberOfSelectableSegments: number;
    type: EAssetType;
    isDisabled?: boolean;
    selectedItemsView: SelectedItemsView;
}
